import { Routes } from '@angular/router';
import { DEFAULT_MODAL_ROUTE_CONFIG } from '@app/common/default-modal-route-config';
import { DEFAULT_ROUTE_CONFIG } from '@app/common/default-route-config';
import { DefaultRoutes } from '@app/common/default-routes';

export const FULL_ROUTE_CONFIG: Routes = [
  DefaultRoutes.USER,
  DefaultRoutes.PAGES,
  ...DEFAULT_ROUTE_CONFIG,
  ...DEFAULT_MODAL_ROUTE_CONFIG
];
